import _createForOfIteratorHelper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
export var insertElementInSet = function insertElementInSet(set, element, predicate, ignoreDuplicates) {
  var _iterator = _createForOfIteratorHelper(set),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var lmnt = _step.value;
      if (predicate(lmnt)) {
        if (ignoreDuplicates) {
          return false;
        }
        throw Error('The set contains at least one similar element.');
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  set.add(element);
  return true;
};